import { z } from 'zod'

export const BuildFiltersQueryArticleSchema = z.object({
  source_provider_id: z.number().optional(),
  excluded_source_provider_ids: z.number().or(z.string()).optional(),
  source_provider_name: z.string().optional(),
  order_by: z.string().optional(),
  order_direction: z.string().optional(),
  is_archived: z.number().optional(),
  sources_ids: z.array(z.number()).optional().transform(value => value?.join(',') ?? value),
  imports_ids: z.array(z.number()).optional().transform(value => value?.join(',') ?? value),
  media_topics: z.array(z.string().or(z.number())).optional().transform(value => value?.join(',') ?? value),
  'metas][genre': z.string().optional(),
  search: z.string().optional(),
  search_title_only: z.number().optional(),
  published_after: z.string().optional(),
  published_before: z.string().optional()
})

export type BuildFiltersQueryArticleSchemaType = z.infer<typeof BuildFiltersQueryArticleSchema>
